import AppSidebar from '@/components/AppSidebar';
import { useSidebar } from '@/context/SidebarContext';
import { Menu } from 'lucide-react';

export default function GlobalLayout({ children, user }) {
  const { collapsed, toggle } = useSidebar();
  const marginClass = collapsed ? 'ml-0 md:ml-16' : 'ml-0 md:ml-56 lg:ml-64';

  return (
    <>
      <AppSidebar user={user} />
      <div
        className={`transition-all duration-300 ${marginClass} min-h-screen`}
        data-testid="global-layout-content"
      >
        {/* Mobile sidebar toggle - visible only when sidebar is hidden on mobile */}
        {collapsed && (
          <button
            onClick={toggle}
            className="fixed top-3 left-3 z-[55] p-2 bg-slate-800/90 backdrop-blur-sm rounded-lg border border-white/10 md:hidden"
            data-testid="mobile-menu-toggle"
          >
            <Menu className="w-5 h-5 text-white" />
          </button>
        )}
        {children}
      </div>
    </>
  );
}
